import * as t from "io-ts";
import { BadResponseBodyError } from "../../bad-response-body-error";
import { HttpError } from "../../http-error";
import { PlainPassword } from "../../types/user/password";
import { User } from "../user";

export const SignUpRequest = t.type({
  email: t.string,
  password: PlainPassword,
  invitationCode: t.string,
});
export type SignUpRequest = t.TypeOf<typeof SignUpRequest>;

export const SignUpResponse = t.type({
  user: User
});
export type SignUpResponse = t.TypeOf<typeof SignUpResponse>;
export type SignUpResponseOutput = t.OutputOf<typeof SignUpResponse>;

export async function signUp(body: SignUpRequest): Promise<SignUpResponse> {
  const res = await fetch("/api/auth/signup", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(SignUpRequest.encode(body)),
  });
  if (res.status === 403) {
    const errorMsg = await res.text();
    console.error(errorMsg);
    throw new HttpError(403, errorMsg ?? "Keine Berechtigung");
  }

  return BadResponseBodyError.throwIfLeft(res.status,
    SignUpResponse.decode(await res.json()));
}
